/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 進捗状況をチェックするミッションの種類をまとめたリクエストモデル
 * 確認対象となるミッションの種類を指定するパラメータ。現状は他サイト間ミッションのみです。
 * @export
 * @interface MissionRewardRequestModel
 */
export interface MissionRewardRequestModel {
    /**
     * ミッションのプロモーションタイプ
     * * OTHER_CONTENT: "サイト間のミッション" (チャンクロで1作品読む など)
     * @type {string}
     * @memberof MissionRewardRequestModel
     */
    missionPromotionsType: MissionRewardRequestModelMissionPromotionsTypeEnum;
}


/**
 * @export
 */
export const MissionRewardRequestModelMissionPromotionsTypeEnum = {
    OTHER_CONTENT: 'otherContent'
} as const;
export type MissionRewardRequestModelMissionPromotionsTypeEnum = typeof MissionRewardRequestModelMissionPromotionsTypeEnum[keyof typeof MissionRewardRequestModelMissionPromotionsTypeEnum];


/**
 * Check if a given object implements the MissionRewardRequestModel interface.
 */
export function instanceOfMissionRewardRequestModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "missionPromotionsType" in value;

    return isInstance;
}

export function MissionRewardRequestModelFromJSON(json: any): MissionRewardRequestModel {
    return MissionRewardRequestModelFromJSONTyped(json, false);
}

export function MissionRewardRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissionRewardRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'missionPromotionsType': json['missionPromotionsType'],
    };
}

export function MissionRewardRequestModelToJSON(value?: MissionRewardRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'missionPromotionsType': value.missionPromotionsType,
    };
}

